<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
          <v-row>
            <v-col cols="12">
              <v-alert v-model="alertFlg" type="success" density="compact" :title=successMsg closable class="ma-2" />
            </v-col>
          </v-row>
          <v-row v-if="$t('importErpStock.label.warning')">
            <v-col cols="12">
              <p v-html="$t('importErpStock.label.warning')" style="color: red"></p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select density="compact" variant="outlined" hide-details="auto" v-model="importTargetSiteCode"
                :items="shopItem" item-title="code_name" item-value="code"
                :label="$t('importErpStock.label.shopCodeList')" />
            </v-col>
            <v-col cols="6">
              <input ref="importBtn" type="file" accept=".csv,.dat" style="display: none" @change="selectedFile" />
              <v-btn dark class="ml-4 bg-indigo-darken-1" elevation="2" @click="onImportBtnClick"
                v-bind:disabled="this.importTargetSiteCode == null">
                {{ $t('importErpStock.action.loadFile') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <ImportErpStockDialog v-if="importErpStockDialogVisible" :dialog-data="importErpStockDialog"
          :handle-ok="showSuccessMessage" :handle-cancel="closeImportDialog" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import ImportErpStockDialog from "@/components/dialog/ImportErpStockDialog";

export default {
  components: { AppWrapperView, ImportErpStockDialog },
  props: {},
  computed: {
  },

  data: () => ({
    importTargetSiteCode: null,
    importErpStockDialogVisible: false,
    importErpStockDialog: {
      siteCode: null,
      siteName: null,
      file: null,
    },
    shopItem: [],
    timeoutId: null,
    alertFlg: false,
    successMsg: "",
  }),

  methods: {
    // 店舗リストの取得(selectSiteFlag：0：他店舗含む / 1：自店舗のみ)
    getValidShopSearchList() {
      api.post("/store/search", { selectSiteFlag: 1 })
        .then((response) => {
          if (response.status == 1) return; //do nothing
          response.data.results?.shopList.forEach(e => {
            this.shopItem.push({ name: e.name, code: e.code, zoneList: e.zoneList, code_name: e.code + '_' + e.name })
          })
        })
        .catch((error) => {
          //do nothing
        })
    },
    // 取込ボタン押下
    onImportBtnClick() {
      this.$refs.importBtn.value = null;
      this.$refs.importBtn.click();
    },
    // 取込本処理
    async selectedFile() {
      const selectedSiteName = this.shopItem.find(x => x.code == this.importTargetSiteCode)?.name;
      this.importErpStockDialog.siteName = selectedSiteName;
      this.importErpStockDialog.siteCode = this.importTargetSiteCode;
      this.importErpStockDialog.file = this.$refs.importBtn.files[0];
      this.importErpStockDialogVisible = true;
    },
    // ダイアログ非表示
    closeImportDialog() {
      this.importErpStockDialogVisible = false;
      this.importErpStockDialog.siteCode = null;
      this.importErpStockDialog.siteName = null;
      this.importErpStockDialog.file = null;
    },
    showSuccessMessage() {
      this.alertFlg = true;
      this.timeoutId = setTimeout(() => {
        this.alertFlg = false;
        this.timeoutId = null;
      }, 5000);
      this.successMsg = this.$t('importErpStock.message.success');
      this.closeImportDialog();
    },
  },
  created() {
    this.getValidShopSearchList()
  },

  unmounted() {
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
      this.alertFlg = false;
    }
  },
};
</script>

<style></style>
